import { defineComponent as _defineComponent } from 'vue'
import VueDraggable from 'vuedraggable';
import MapStylePropertiesListItem from '@/components/DesignStudio/MapStyleProperties/components/list/item/MapStylePropertiesListItem.vue';

interface Emits {
    (
        event: 'update',
        data: {
            id: number;
            value: string;
        }
    ): void;
    (event: 'remove', mapStyle: string): void;
    (event: 'reorder', mapStyles: string[]): void;
    (event: 'set-default', id: number): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MapStylePropertiesList',
  props: {
    items: null,
    disabled: { type: Boolean },
    defaultStyle: null
  },
  emits: ["update", "remove", "reorder", "set-default"],
  setup(__props: any, { emit }: { emit: ({
    (
        event: 'update',
        data: {
            id: number;
            value: string;
        }
    ): void;
    (event: 'remove', mapStyle: string): void;
    (event: 'reorder', mapStyles: string[]): void;
    (event: 'set-default', id: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    items: string[];
    disabled?: boolean;
    defaultStyle: string;
};





const handleUpdate = (data: { id: number; value: string }) => {
    emit('update', data);
};

const handleRemove = (mapStyle: string) => {
    emit('remove', mapStyle);
};

const handleReorder = () => {
    emit('reorder', props.items);
};
const handleSetDefault = (id: number) => {
    emit('set-default', id);
};

return { __sfc: true,props, emit, handleUpdate, handleRemove, handleReorder, handleSetDefault, VueDraggable, MapStylePropertiesListItem }
}

})